import {z} from 'zod';

import {directSalesFiltersSchema} from './DirectSalesFiltersSchema';

export const directSalesByMonthSchema = z.object({
  month: z.string(),
  labourRevenue: z.number(),
  materialRevenue: z.number(),
  totalRevenue: z.number(),
  labourMargin: z.number(),
  materialMargin: z.number(),
  totalMargin: z.number(),
  labourDiscount: z.number(),
  materialDiscount: z.number(),
  totalDiscount: z.number(),
  salesCount: z.number(),
});

export type DirectSalesByMonth = z.infer<typeof directSalesByMonthSchema>;

export const directSalesSummarySchema = directSalesByMonthSchema
  .omit({month: true})
  .extend({averageMarginPercent: z.number()});

export type DirectSalesSummary = z.infer<typeof directSalesSummarySchema>;

export const directSalesByMonthResponseSchema = z.object({
  data: z.array(directSalesByMonthSchema),
  summary: directSalesSummarySchema,
  filters: directSalesFiltersSchema,
});

export type DirectSalesByMonthResponse = z.infer<typeof directSalesByMonthResponseSchema>;
